import { render, staticRenderFns } from "./del-post-dialog.vue?vue&type=template&id=6802109c&"
import script from "./del-post-dialog.vue?vue&type=script&lang=js&"
export * from "./del-post-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports